import React, { useState } from "react";
import { Skeleton } from "@mui/material";
import BtnOutline from "../../../components/button/BtnOutline";
import "../process.css";
import { withTranslation } from "react-i18next";

const CargoDetails = ({ loading, clientNotes, t }) => {
  const [showmore, setShowmore] = useState(true);
  const clickShowmore = () => {
    showmore ? setShowmore(false) : setShowmore(true);
  };
  return (
    <React.Fragment>
      {loading ? (
        <Skeleton
          variant="rectangular"
          height={120}
          style={{ width: "100%", marginBottom: "1rem" }}
        />
      ) : (
        <>
          {clientNotes.length ? (
            <div className="payment">
              <p className="color-grey2 payment-heading">{t("CargoDetails")}</p>
              {clientNotes.map((note, index) =>
                note.LegNotes?.trim() ? (
                  <p
                    className="color-grey"
                    key={index}
                    style={{
                      fontSize: "16px",
                      fontFamily: "siena-semibold",
                      color: "var(--color-gray7)",
                    }}
                  >
                    {note.LegNotes}
                  </p>
                ) : null
              )}
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(CargoDetails);
